import { constants } from "../config";
import AuthService from "../tools/AuthService";

export const login = (values) => {
  return submit(values, `${constants.api}/login`);
};
export const signup = (values) => {
  return submit(values, `${constants.api}/signup`);
};

const submit = (values, url) => {
  return (dispatch) => {
    console.log(values);
    AuthService.post(url, values)
      .then((resp) => {
        if (resp.ok) {
          dispatch({ type: "USER_FETCHED", payload: resp.response });
          dispatch({ type: "close" });
        } else
          dispatch({
            type: "showError",
            payload: { message: "Usuário ou senha inválidos." },
          });
      })
      .catch((error) => {
        dispatch({
          type: "showError",
          payload: { message: "Usuário ou senha inválidos." },
        });
      });
  };
};

export const logout = () => {
  return { type: "TOKEN_VALIDATED", payload: false };
};

export const validateToken = (token) => {
  return (dispatch) => {
    AuthService.post(`${constants.api}/validate-token`, { token })
      .then((resp) => {
        if (resp.ok)
          dispatch({ type: "TOKEN_VALIDATED", payload: resp.response.auth });
        else dispatch({ type: "TOKEN_VALIDATED", payload: !!token });
      })
      .catch((error) => {
        dispatch({ type: "TOKEN_VALIDATED", payload: !!token });
      });
  };
};



// WEBPACK FOOTER //
// ./src/actions/authActions.js